export default __webpack_public_path__ + "static/men3-e7d4715aad9e0a4fb3b5055dd1eeae96.webp";